// @ts-ignore
import { createRoot } from "react-dom/client";
import App from "./App";

import "./css/style.scss";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthProvider } from "hooks/auth";
import { ApiProvider } from "hooks/api";
import { ReactQueryDevtools } from "react-query/devtools";
import { SessionDetailsProvider } from "hooks/sessionDetails";
import { SnackbarProvider } from "notistack";
import AutoLogin from "components/AutoLogin";
import { ConnectorConfigProvider } from "hooks/connectorConfig";

const queryClient = new QueryClient();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ConnectorConfigProvider
    initialState={{
      clientId: "",
      host: "",
      username: "",
      password: "",
      timeout: false,
    }}
  >
    <SnackbarProvider
      maxSnack={2}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      autoHideDuration={3000}
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider initialState={{ isLoggedIn: false }}>
          <SessionDetailsProvider>
            <ApiProvider>
              <AutoLogin>
                <App />
              </AutoLogin>
            </ApiProvider>
          </SessionDetailsProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </SnackbarProvider>
  </ConnectorConfigProvider>
);
